import api from '../httpClient';
import type { ResponsePayload } from 'types';
import type { EvaluationAnswer } from 'utils/answerEvaluation';
import { courseRuntimeUrl } from './courseRuntimeContext';

export interface AnswerEvaluationState {
  status: 'not_started' | 'needs_follow_up' | 'evaluating' | 'completed';
  revision: number;
  original_answer: EvaluationAnswer | null;
  turns: Array<{ question: string; answer: string | null }>;
  /** `references_changed`: an earlier answer quoted in the question changed mid-check; re-evaluate. */
  outcome: 'criteria_met' | 'limit_reached' | 'skipped' | 'unavailable' | 'references_changed' | null;
  completeness: number | null;
  follow_up_question: string | null;
  max_follow_ups: number;
  response: ResponsePayload | null;
  retry_required?: boolean;
  restart_required?: boolean;
}

export interface AnswerEvaluationRequest {
  flow_run: number;
  generation_id?: number;
  request_id: string;
  expected_revision: number;
  action: 'evaluate' | 'reply' | 'restart' | 'skip' | 'continue_without_evaluation';
  /** REQ-106 digest of the earlier answers this question displayed. */
  reference_digest?: string;
  answer?: EvaluationAnswer;
  reply?: string;
}

const endpoint = (flowName: string, flowItemId: number) =>
  courseRuntimeUrl(`/api/flows/${encodeURIComponent(flowName)}/answer-evaluation/${flowItemId}/`);

export const answerEvaluation = {
  get: (flowName: string, flowItemId: number, flowRunId: number) =>
    api.get<AnswerEvaluationState>(endpoint(flowName, flowItemId), { params: { flow_run: flowRunId } }),
  submit: (flowName: string, flowItemId: number, payload: AnswerEvaluationRequest) =>
    api.post<AnswerEvaluationState>(endpoint(flowName, flowItemId), payload),
};
